// extracted by mini-css-extract-plugin
export default {"confirmAccountContainer":"_32JroDZEdBZxiDATTQbBHl","textContainer":"_2caBfRzO1GTm-3TZhpqbtb","infoTitle":"_3lxtMysVHkqae-fqQGWhQf"};